import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import PipelineEditor from './PipelineEditor';

const PipelinesConfig = ({ show, onClose }) => {

    const [pipelines, setPipelines] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isVisible, setIsVisible] = useState(false);
    const [editingPipeline, setEditingPipeline] = useState(null);
    const [showEditor, setShowEditor] = useState(false);
    const [erro, setErro] = useState(null);

    useEffect(() => {
        if (show) {
            setTimeout(() => setIsVisible(true), 10);
            fetchPipelines();
        } else {
            setIsVisible(false);
        }
    }, [show]);

    const fetchPipelines = async () => {
        setIsLoading(true);
        setErro(null);
        try {
            const response = await axios.get('/api/pipelines');
            setPipelines(response.data.pipelines || []);
        } catch (err) {
            setErro('Não foi possível carregar as pipelines.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(() => onClose(), 300);
    };

    const handleNovaPipeline = () => {
        setEditingPipeline(null);
        setShowEditor(true);
    };

    const handleEditarPipeline = (pipeline) => {
        setEditingPipeline(pipeline);
        setShowEditor(true);
    };

    const handleSetDefault = async (pipeline) => {
        try {
            await axios.post(`/api/pipelines/${pipeline.id}/default`);
            fetchPipelines();
        } catch (err) {
            setErro('Não foi possível definir como padrão.');
        }
    };

    const handleDeletePipeline = async (pipeline) => {
        if (!window.confirm(`Deseja excluir a pipeline "${pipeline.nome}"?`)) return;
        try {
            await axios.delete(`/api/pipelines/${pipeline.id}`);
            fetchPipelines();
        } catch (err) {
            setErro(err.response?.data?.message || 'Não foi possível excluir a pipeline.');
        }
    };

    const handleSavePipeline = () => {
        setShowEditor(false);
        fetchPipelines();
    };

    if (!show) return null;

    return (
        <>
            {/* Overlay */}
            <div
                onClick={handleClose}
                style={{
                    position: 'fixed', inset: 0,
                    backgroundColor: 'rgba(0,0,0,0.4)',
                    zIndex: 1040,
                    opacity: isVisible ? 1 : 0,
                    transition: 'opacity 0.3s ease',
                }}
            />

            {/* Drawer */}
            <div style={{
                position: 'fixed',
                top: 0, right: 0, bottom: 0,
                width: '100%', maxWidth: '680px',
                backgroundColor: '#f9fafb',
                zIndex: 1050,
                display: 'flex',
                flexDirection: 'column',
                transform: isVisible ? 'translateX(0)' : 'translateX(100%)',
                transition: 'transform 0.3s ease',
                boxShadow: '-4px 0 24px rgba(0,0,0,0.15)',
            }}>
                {/* Botão fechar flutuante */}
                <button
                    onClick={handleClose}
                    style={{
                        position: 'absolute', top: '24px', left: '-18px',
                        width: '36px', height: '36px', borderRadius: '50%',
                        backgroundColor: '#fff', border: '1px solid #e5e7eb',
                        cursor: 'pointer', display: 'flex',
                        alignItems: 'center', justifyContent: 'center',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)', zIndex: 10,
                    }}
                >
                    <FontAwesomeIcon icon="times" style={{ fontSize: `calc(14px * var(--font-scale))`, color: '#374151' }} />
                </button>

                {/* Header */}
                <div style={{
                    padding: '24px 28px 20px',
                    backgroundColor: '#fff',
                    borderBottom: '1px solid #e5e7eb',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                }}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#111827' }}>
                            <FontAwesomeIcon icon="project-diagram" style={{ marginRight: '10px', color: '#3b82f6' }} />
                            Pipelines
                        </h2>
                        <p style={{ margin: '4px 0 0', fontSize: `calc(13px * var(--font-scale))`, color: '#6b7280' }}>
                            Configure os funis de atendimento da sua clínica
                        </p>
                    </div>
                    <button
                        onClick={handleNovaPipeline}
                        style={{
                            padding: '8px 16px', backgroundColor: '#3b82f6',
                            color: '#fff', border: 'none', borderRadius: '8px',
                            cursor: 'pointer', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600',
                            display: 'flex', alignItems: 'center', gap: '6px',
                        }}
                    >
                        <FontAwesomeIcon icon="plus" />
                        Nova Pipeline
                    </button>
                </div>

                {/* Conteúdo */}
                <div style={{ flex: 1, overflowY: 'auto', padding: '24px 28px' }}>
                    {erro && (
                        <div style={{
                            backgroundColor: '#fef2f2', border: '1px solid #fecaca',
                            borderRadius: '8px', padding: '12px 16px',
                            color: '#dc2626', fontSize: `calc(13px * var(--font-scale))`, marginBottom: '16px',
                        }}>
                            <FontAwesomeIcon icon="exclamation-circle" style={{ marginRight: '8px' }} />
                            {erro}
                        </div>
                    )}

                    {isLoading ? (
                        <div style={{ textAlign: 'center', padding: '60px' }}>
                            <Spinner animation="border" variant="primary" />
                            <p style={{ marginTop: '12px', color: '#6b7280' }}>Carregando pipelines...</p>
                        </div>
                    ) : pipelines.length === 0 ? (
                        <div style={{
                            textAlign: 'center', padding: '60px',
                            backgroundColor: '#fff', borderRadius: '12px',
                            border: '2px dashed #e5e7eb',
                        }}>
                            <FontAwesomeIcon icon="project-diagram" style={{ fontSize: '48px', color: '#d1d5db', marginBottom: '16px' }} />
                            <h3 style={{ color: '#374151', fontSize: '16px', fontWeight: '600' }}>
                                Nenhuma pipeline configurada
                            </h3>
                            <p style={{ color: '#9ca3af', fontSize: `calc(13px * var(--font-scale))`, marginBottom: '20px' }}>
                                Crie sua primeira pipeline para organizar os leads
                            </p>
                            <button
                                onClick={handleNovaPipeline}
                                style={{
                                    padding: '10px 20px', backgroundColor: '#3b82f6',
                                    color: '#fff', border: 'none', borderRadius: '8px',
                                    cursor: 'pointer', fontSize: `calc(14px * var(--font-scale))`, fontWeight: '600',
                                }}
                            >
                                <FontAwesomeIcon icon="plus" style={{ marginRight: '8px' }} />
                                Criar Pipeline
                            </button>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            {pipelines.map(pipeline => (
                                <PipelineCard
                                    key={pipeline.id}
                                    pipeline={pipeline}
                                    onEditar={() => handleEditarPipeline(pipeline)}
                                    onSetDefault={() => handleSetDefault(pipeline)}
                                    onDeletar={() => handleDeletePipeline(pipeline)}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* Editor de Pipeline */}
            {showEditor && (
                <PipelineEditor
                    show={showEditor}
                    pipeline={editingPipeline}
                    onClose={() => setShowEditor(false)}
                    onSave={handleSavePipeline}
                />
            )}
        </>
    );
};

// ─── Card de Pipeline ────────────────────────────────────────────────────────

const PipelineCard = ({ pipeline, onEditar, onSetDefault, onDeletar }) => {
    const totalLeads = pipeline.leads?.length || 0;
    const totalEstagios = pipeline.estagios?.length || 0;

    return (
        <div style={{
            backgroundColor: '#fff',
            borderRadius: '12px',
            border: `1px solid ${pipeline.is_default ? '#bfdbfe' : '#e5e7eb'}`,
            overflow: 'hidden',
            boxShadow: pipeline.is_default ? '0 0 0 2px #3b82f620' : 'none',
            transition: 'box-shadow 0.2s',
        }}>
            {/* Header do card */}
            <div style={{
                padding: '16px 20px',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                borderBottom: '1px solid #f3f4f6',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    {/* Cor da pipeline */}
                    <div style={{
                        width: '40px', height: '40px', borderRadius: '10px',
                        backgroundColor: `${pipeline.cor}22`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                    }}>
                        <FontAwesomeIcon icon="project-diagram" style={{ color: pipeline.cor, fontSize: '16px' }} />
                    </div>

                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '600', color: '#111827' }}>
                                {pipeline.nome}
                            </span>
                            {pipeline.is_default && (
                                <span style={{
                                    fontSize: `calc(10px * var(--font-scale))`, fontWeight: '600',
                                    backgroundColor: '#dbeafe', color: '#1d4ed8',
                                    padding: '2px 8px', borderRadius: '999px',
                                }}>
                                    ★ PADRÃO
                                </span>
                            )}
                            {!pipeline.is_active && (
                                <span style={{
                                    fontSize: `calc(10px * var(--font-scale))`, fontWeight: '600',
                                    backgroundColor: '#f3f4f6', color: '#9ca3af',
                                    padding: '2px 8px', borderRadius: '999px',
                                }}>
                                    INATIVA
                                </span>
                            )}
                        </div>
                        {pipeline.descricao && (
                            <p style={{ margin: '2px 0 0', fontSize: `calc(12px * var(--font-scale))`, color: '#9ca3af' }}>
                                {pipeline.descricao}
                            </p>
                        )}
                    </div>
                </div>

                {/* Ações */}
                <div style={{ display: 'flex', gap: '8px' }}>
                    {!pipeline.is_default && (
                        <button
                            onClick={onSetDefault}
                            title="Definir como padrão"
                            style={{
                                padding: '6px 10px', borderRadius: '6px',
                                backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb',
                                cursor: 'pointer', fontSize: `calc(12px * var(--font-scale))`, color: '#6b7280',
                                display: 'flex', alignItems: 'center', gap: '4px',
                            }}
                        >
                            <FontAwesomeIcon icon="star" />
                            Padrão
                        </button>
                    )}
                    <button
                        onClick={onEditar}
                        style={{
                            padding: '6px 12px', borderRadius: '6px',
                            backgroundColor: '#eff6ff', border: '1px solid #bfdbfe',
                            cursor: 'pointer', fontSize: `calc(12px * var(--font-scale))`, color: '#3b82f6',
                            display: 'flex', alignItems: 'center', gap: '4px',
                            fontWeight: '500',
                        }}
                    >
                        <FontAwesomeIcon icon="edit" />
                        Editar
                    </button>
                    {!pipeline.is_default && (
                        <button
                            onClick={onDeletar}
                            style={{
                                padding: '6px 10px', borderRadius: '6px',
                                backgroundColor: '#fef2f2', border: '1px solid #fecaca',
                                cursor: 'pointer', fontSize: `calc(12px * var(--font-scale))`, color: '#ef4444',
                            }}
                        >
                            <FontAwesomeIcon icon="trash" />
                        </button>
                    )}
                </div>
            </div>

            {/* Estágios preview */}
            <div style={{ padding: '12px 20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                    {(pipeline.estagios || []).map((estagio, index) => (
                        <React.Fragment key={estagio.id}>
                            <div style={{
                                display: 'flex', alignItems: 'center', gap: '4px',
                                padding: '4px 10px', borderRadius: '999px',
                                backgroundColor: `${estagio.cor}18`,
                                border: `1px solid ${estagio.cor}44`,
                                fontSize: `calc(11px * var(--font-scale))`, fontWeight: '500', color: estagio.cor,
                            }}>
                                {estagio.tipo === 'entrada' && <FontAwesomeIcon icon="sign-in-alt" style={{ fontSize: '9px' }} />}
                                {estagio.tipo === 'convertido' && <FontAwesomeIcon icon="check-circle" style={{ fontSize: '9px' }} />}
                                {estagio.tipo === 'perdido' && <FontAwesomeIcon icon="times-circle" style={{ fontSize: '9px' }} />}
                                {estagio.nome}
                            </div>
                            {index < pipeline.estagios.length - 1 && (
                                <FontAwesomeIcon icon="chevron-right" style={{ fontSize: `calc(10px * var(--font-scale))`, color: '#d1d5db' }} />
                            )}
                        </React.Fragment>
                    ))}
                </div>

                {/* Métricas */}
                <div style={{ display: 'flex', gap: '16px', marginTop: '10px' }}>
                    <span style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#9ca3af' }}>
                        <FontAwesomeIcon icon="users" style={{ marginRight: '4px', color: '#3b82f6' }} />
                        {totalLeads} leads
                    </span>
                    <span style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#9ca3af' }}>
                        <FontAwesomeIcon icon="columns" style={{ marginRight: '4px', color: '#8b5cf6' }} />
                        {totalEstagios} estágios
                    </span>
                </div>
            </div>
        </div>
    );
};

export default PipelinesConfig;
